export default __webpack_public_path__ + "static/media/bcg-union@2x-TEMNO.be879535.png";